export const TRAVELER_PROFILES = [
  {
    id: 'active-globetrotter',
    iconName: 'Mountain',
    color: '#EF4444',
    title: 'The Active Globetrotter',
    description: 'Adventure-seeking travelers who prioritize physical activities like hiking, climbing, and outdoor sports',
    keywords: ['adventure', 'hiking', 'climbing', 'outdoors', 'sports', 'active']
  },
  {
    id: 'eco-conscious',
    iconName: 'Leaf',
    color: '#10B981',
    title: 'The Eco-Conscious Traveler',
    description: 'Environmentally responsible travelers focused on sustainable tourism and eco-friendly practices',
    keywords: ['sustainable', 'eco-friendly', 'green', 'environment', 'conservation', 'responsible']
  },
  {
    id: 'van-lifer',
    iconName: 'Caravan',
    color: '#F59E0B',
    title: 'The Van Lifer',
    description: 'Freedom-loving road trippers who enjoy traveling by van and camping',
    keywords: ['van life', 'road trip', 'camping', 'freedom', 'nomadic', 'mobile']
  },
  {
    id: 'off-grid',
    iconName: 'Compass',
    color: '#2C4251',
    title: 'The Off-the-Grid Traveler',
    description: 'Adventurers seeking remote destinations and wilderness experiences',
    keywords: ['remote', 'wilderness', 'off-grid', 'isolation', 'nature', 'rustic']
  },
  {
    id: 'digital-nomad',
    iconName: 'Laptop',
    color: '#7DADC1',
    title: 'The Digital Nomad',
    description: 'Remote workers combining travel with work, seeking good wifi and coworking spaces',
    keywords: ['remote work', 'wifi', 'coworking', 'work-travel', 'flexible', 'connected']
  },
  {
    id: 'wellness',
    iconName: 'Heart',
    color: '#7DADC1',
    title: 'The Wellness Traveler',
    description: 'Health-focused travelers seeking yoga, meditation, spas, and mindful experiences',
    keywords: ['wellness', 'yoga', 'meditation', 'spa', 'health', 'mindfulness', 'relaxation']
  },
  {
    id: 'backpacker',
    iconName: 'MapPin',
    color: '#EF8557',
    title: 'The Backpacker',
    description: 'Budget-conscious travelers staying in hostels and seeking authentic local experiences',
    keywords: ['budget', 'hostels', 'backpacking', 'authentic', 'local', 'frugal']
  },
  {
    id: 'cultural-explorer',
    iconName: 'Landmark',
    color: '#4A7B91',
    title: 'The Cultural Explorer',
    description: 'History and culture enthusiasts visiting museums, historical sites, and local traditions',
    keywords: ['culture', 'history', 'museums', 'heritage', 'traditions', 'learning']
  },
  {
    id: 'beach-bum',
    iconName: 'Sun',
    color: '#FFDB70',
    title: 'The Beach Bum',
    description: 'Sun and sea lovers seeking coastal destinations and water activities',
    keywords: ['beach', 'ocean', 'swimming', 'surfing', 'coastal', 'tropical', 'sun']
  },
  {
    id: 'nature-lover',
    iconName: 'TreePine',
    color: '#10B981',
    title: 'The Nature Lover',
    description: 'Nature enthusiasts exploring national parks, wildlife, and natural wonders',
    keywords: ['nature', 'wildlife', 'national parks', 'forests', 'mountains', 'scenery']
  },
  {
    id: 'family-traveler',
    iconName: 'Users',
    color: '#7DADC1',
    title: 'The Family Traveler',
    description: 'Families seeking kid-friendly activities and comfortable accommodations',
    keywords: ['family', 'kids', 'children', 'family-friendly', 'safe', 'educational']
  },
  {
    id: 'party-animal',
    iconName: 'Music',
    color: '#EF8557',
    title: 'The Party Animal',
    description: 'Nightlife enthusiasts seeking clubs, bars, rooftop parties, and vibrant social scenes',
    keywords: ['nightlife', 'clubs', 'bars', 'party', 'social', 'dancing', 'rooftop']
  },
  {
    id: 'city-tripper',
    iconName: 'Building',
    color: '#2C4251',
    title: 'The City Tripper',
    description: 'Urban explorers who love city walks, cafés, architecture, shopping, and the buzz of big cities',
    keywords: ['city', 'urban', 'architecture', 'shopping', 'cafés', 'metropolitan', 'sightseeing']
  },
  {
    id: 'foodie',
    iconName: 'UtensilsCrossed',
    color: '#F59E0B',
    title: 'The Foodie',
    description: 'Culinary travelers who plan their trip around local cuisine, street food, markets, and memorable restaurants',
    keywords: ['food', 'cuisine', 'restaurants', 'street food', 'markets', 'culinary', 'wine', 'dining']
  }
];

export const WHO_IS_COMING_OPTIONS = [
  { value: 'solo', label: 'Solo', iconName: 'User' },
  { value: 'partner', label: 'Partner', iconName: 'Heart' },
  { value: 'kids', label: 'Kids', iconName: 'Baby' },
  { value: 'friends', label: 'Friends', iconName: 'Users' },
  { value: 'elderly', label: 'Elderly', iconName: 'PersonStanding' },
  { value: 'pets', label: 'Pets', iconName: 'PawPrint' },
  { value: 'undecided', label: 'Still figuring it out', iconName: 'HelpCircle' },
];

export const TRAVEL_PACE_OPTIONS = [
  { value: 'relaxed', label: 'Relaxed', iconName: 'Minus', color: '#7DADC1', description: '1-2 activities per day, plenty of downtime and slow mornings' },
  { value: 'moderate', label: 'Moderate', iconName: 'Footprints', color: '#10B981', description: '2 activities per day, balanced with free time' },
  { value: 'balanced', label: 'Balanced', iconName: 'Scale', color: '#FFDB70', description: '3 activities per day, good mix of action and rest' },
  { value: 'active', label: 'Active', iconName: 'TrendingUp', color: '#EF8557', description: '3-4 activities per day, busy but manageable' },
  { value: 'packed', label: 'Packed', iconName: 'Zap', color: '#EF4444', description: '4+ activities per day, maximize every moment' }
];

export const BUDGET_OPTIONS = [
  { value: 'low', label: 'Budget', iconName: 'Wallet', color: '#10B981', symbol: '$', description: 'Hostels, street food, free activities' },
  { value: 'medium', label: 'Moderate', iconName: 'Banknote', color: '#7DADC1', symbol: '$$', description: 'Mid-range hotels, local restaurants, paid attractions' },
  { value: 'high', label: 'Comfortable', iconName: 'Gem', color: '#FFDB70', symbol: '$$$', description: 'Nice hotels, good restaurants, premium experiences' },
  { value: 'luxury', label: 'Luxury', iconName: 'Crown', color: '#EF8557', symbol: '$$$$', description: 'Luxury hotels, fine dining, exclusive experiences' }
];

export const ACTIVITY_CATEGORIES = [
  { value: 'food', label: 'Food & Dining', iconName: 'UtensilsCrossed', color: '#F59E0B' },
  { value: 'nature', label: 'Nature & Outdoors', iconName: 'TreePine', color: '#10B981' },
  { value: 'culture', label: 'Culture & History', iconName: 'Landmark', color: '#4A7B91' },
  { value: 'adventure', label: 'Adventure & Sports', iconName: 'Mountain', color: '#C85A2E' },
  { value: 'relaxation', label: 'Relaxation & Wellness', iconName: 'Heart', color: '#7DADC1' },
  { value: 'shopping', label: 'Shopping', iconName: 'ShoppingBag', color: '#F0C84D' },
  { value: 'nightlife', label: 'Nightlife', iconName: 'Moon', color: '#2C4251' },
  { value: 'transport', label: 'Transportation', iconName: 'Plane', color: '#386074' },
  { value: 'accommodation', label: 'Accommodation', iconName: 'Hotel', color: '#4A7B91' },
  { value: 'other', label: 'Other', iconName: 'MapPin', color: '#71717A' }
];

export const ACCOMMODATION_TYPES = [
  { value: 'hotel', label: 'Hotel', iconName: 'Hotel' },
  { value: 'hostel', label: 'Hostel', iconName: 'BedDouble' },
  { value: 'airbnb', label: 'Airbnb', iconName: 'Home' },
  { value: 'guesthouse', label: 'Guesthouse', iconName: 'House' },
  { value: 'resort', label: 'Resort', iconName: 'Palmtree' },
  { value: 'camping', label: 'Camping', iconName: 'Tent' },
  { value: 'other', label: 'Other', iconName: 'MapPin' }
];
